export default __webpack_public_path__ + "static/media/keenhomepro_logo.ff0d6a56.svg";